import React from "react";
import PropTypes from "prop-types";
import { css } from "emotion";
import { useNewOffer } from "../../../js/context/new-offer";

import { styleItemCardInfoRanking } from "./styles";
import RankingOffers from "../RankingOffers/RankingOffers";
import { floatFormat } from "../utils/formats";

export const ItemCardInfoRanking = ({ mobile }) => {
	const { offerData, pricesData, rankingData } = useNewOffer();

	const { minMiles, maxMiles, minPrice, maxPrice } = pricesData.data;

	const { price, quant } = offerData.data;

	const applyHotjar = () => {
		const getHotjar = () => {
			const hj = window.hj;
			const isHjAvailable = hj && hj.globals && hj.globals.get;
			if (isHjAvailable) {
				return hj;
			}

			return undefined;
		};

		const hj = getHotjar();

		if (hj) {
			hj("trigger", "offer-miles-ranking");
		}
	};

	const handlerRanking = data => {
		let newPrice = parseFloat(price) ? floatFormat(price) : 0;
		let newMiles = parseInt(quant) ? parseInt(quant) : 0;
		let ruleToShowRanking =
			newPrice >= minPrice && newPrice <= maxPrice && newMiles >= minMiles && newMiles <= maxMiles;

		if (Object.getOwnPropertyNames(data).length > 2 && ruleToShowRanking) {
			applyHotjar();
			return (
				<>
					{!mobile && <p className="title--ranking">Ranking de ofertas</p>}
					<RankingOffers mobile={mobile} />
				</>
			);
		}
	};

	return (
		<div
			className={css`
				${styleItemCardInfoRanking};
			`}
		>
			{!mobile && (
				<>
					<p className="title">Valor das suas milhas</p>
					<p>
						Informe qual é o valor que você quer receber por cada 1.000 milhas vendidas nesta
						oferta.
						<br />
						<br />O valor indicado por você define sua posição em nosso{" "}
						<strong>ranking de ofertas</strong>. Quanto melhor a posição no ranking, mais rápidas
						serão suas vendas.
					</p>
				</>
			)}

			{handlerRanking(rankingData.data)}
		</div>
	);
};

ItemCardInfoRanking.propTypes = {
	rankingData: PropTypes.object
};
